import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Page } from '../domain/page.model';
import { UserActivity } from '../../kitchen/shared/components/activity/user-activity.model';
import { UserActivityRequest } from '../../kitchen/shared/components/activity/user-activity-request.model';
import { ReportActivityByStage, ReportActivityByDepartment, ReportActivityBySalesRep, ReportActivityByType } from '../../kitchen/shared/components/activity/report-activity.model';
import { HttpUtils } from '../utils/http-utils';


@Injectable()
export class AdStatsUserActivityService {

  constructor(private http: HttpClient) {
  }


  getActivities(params: UserActivityRequest): Observable<Page<UserActivity>> {
    return this.http.get<Page<UserActivity>>(`${environment.serviceUrl}/ad-stats/user-activity`, {
      params: HttpUtils.getHttpParams(params)
    });
  }

  getActivitiesById(id: string): Observable<UserActivity> {
    return this.http.get<UserActivity>(`${environment.serviceUrl}/ad-stats/user-activity/${id}`);
  }

  createActivity(userActivity: UserActivity): Observable<UserActivity> {
    return this.http.post<UserActivity>(`${environment.serviceUrl}/ad-stats/user-activity`, userActivity);
  }

  updateActivity(userActivity: UserActivity): Observable<UserActivity> {
    return this.http.put<UserActivity>(`${environment.serviceUrl}/ad-stats/user-activity/${userActivity.id}`, userActivity);
  }

  uploadActivityFile(file: File, id: string): Observable<UserActivity> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<any>(`${environment.serviceUrl}/ad-stats/user-activity/${id}/files`, formData);
  }

  deleteActivity(userActivity: UserActivity): Observable<any> {
    return this.http.delete<any>(`${environment.serviceUrl}/ad-stats/user-activity/${userActivity.id}`);
  }

  deleteActivityFile(fileName: string, id: string): Observable<any> {
    return this.http.delete<any>(`${environment.serviceUrl}/ad-stats/user-activity/${id}/files?name=${fileName}`);
  }


  // activity reports
  getActivityReportByStage(dateFrom: string, dateTo: string): Observable<ReportActivityByStage[]> {
    return this.http.get<ReportActivityByStage[]>(`${environment.serviceUrl}/ad-stats/user-activity/report/stage?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  }

  getActivityReportByDepartment(dateFrom: string, dateTo: string): Observable<ReportActivityByDepartment> {
    return this.http.get<ReportActivityByDepartment>(`${environment.serviceUrl}/ad-stats/user-activity/report/department?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  }

  getActivityReportByType(dateFrom: string, dateTo: string): Observable<ReportActivityByType[]> {
    return this.http.get<ReportActivityByType[]>(`${environment.serviceUrl}/ad-stats/user-activity/report/type?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  }

  getActivityReportBySalesRepresentative(dateFrom: string, dateTo: string): Observable<ReportActivityBySalesRep[]> {
    return this.http.get<ReportActivityBySalesRep[]>(`${environment.serviceUrl}/ad-stats/user-activity/report/salesrep?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  }

  exportActivityReport(params: any): Observable<any> {
    return this.http.get(`${environment.serviceUrl}/ad-stats/user-activity/export`, { params: HttpUtils.getHttpParams(params), responseType: 'blob' });
  }

}
